import React from 'react';
import { Box } from '../core';
import { IS_NATIVE } from '@r3l/common';
import { Pressable as RPressable } from 'react-native';
import { Link } from './link';
import { LinkProps, StyleProps } from './types';

export const Pressable = ({
  bgHover,
  bg,
  disabled,
  sx,
  ...linkProps
}: StyleProps & LinkProps): JSX.Element => {
  return IS_NATIVE ? (
    <Link {...linkProps} disabled={disabled} />
  ) : (
    <RPressable disabled={disabled}>
      {({ hovered }: any) => (
        <Box sx={{ bg: hovered ? bgHover : bg, ...sx }}>
          <Link {...linkProps} disabled={disabled} />
        </Box>
      )}
    </RPressable>
  );
};

export const HoverEl = ({
  bgHover,
  bg,
  disabled,
  children,
}: {
  bgHover?: string;
  disabled?: boolean;
  bg?: string;
  children: JSX.Element;
}): JSX.Element => {
  return IS_NATIVE ? (
    children
  ) : (
    <RPressable disabled={disabled}>
      {({ hovered }: any) => <Box sx={{ bg: hovered ? bgHover : bg }}>{children}</Box>}
    </RPressable>
  );
};
